<h2>
  <i class="fas fa-chart-line"></i
  ><span class="label">Back Office Stats (BOSS)</span>
</h2>
<app-table>
  <ng-template #empty>
    <app-table-content-empty>
      <ng-container nodata>
        <p>No BOSS statistics</p>
      </ng-container>
    </app-table-content-empty>
  </ng-template>

  <app-table-content
    *ngIf="(bossReports$ | async) && (bossReports$ | async)?.length; else empty"
  >
    <app-table-row
      *ngFor="
        let report of bossReports$ | async;
        trackBy: trackByBossFn;
        let i = index
      "
    >
      <ng-container
        *ngIf="
          i == 0 &&
            +report.month === currentMonth &&
            +report.year === currentYear;
          else olderReports
        "
      >
        <app-table-cell class="flex-half currentReport date"
          >{{ report.month - 1 | month }} {{ report.year }}</app-table-cell
        >
        <app-table-cell>
          <div>ongoing, updates weekly</div>
          <div>
            last updated on
            {{ report.dataLastCollected | date: "MMM dd 'at' H:mm" }}
          </div>
          <div *ngIf="report.dataCollectionLastRequested">
            last requested date on
            {{ report.dataCollectionLastRequested | date: "MMM dd 'at' H:mm" }}
          </div>
        </app-table-cell>
        <app-table-cell class="flex-half">
          <div class="action-buttons">
            <button
              class="btn btn-outline-primary"
              [ngClass]="{
                disabled:
                  (hasOrderManagerRole$ | async) === false ||
                  report.isRefreshing
              }"
              (click)="refresh(report)"
            >
              Refresh
            </button>
            <button
              class="btn btn-outline-primary"
              [ngClass]="{ disabled: report.isDownloading }"
              (click)="download(report)"
            >
              Download XLS
            </button>
          </div>
        </app-table-cell>
      </ng-container>
      <ng-template #olderReports>
        <app-table-cell class="flex-half"
          >{{ report.month - 1 | month }} {{ report.year }}</app-table-cell
        >
        <app-table-cell
          >last updated on
          {{
            report.dataLastCollected | date: "MMM dd 'at' H:mm"
          }}</app-table-cell
        >
        <app-table-cell class="flex-half">
          <div class="action-buttons">
            <button
              class="btn btn-outline-primary"
              [ngClass]="{ disabled: report.isDownloading }"
              (click)="download(report)"
            >
              Download XLS
            </button>
          </div>
        </app-table-cell>
      </ng-template>
    </app-table-row>
  </app-table-content>
</app-table>
